import { render, staticRenderFns } from "./AdvantagesSection.vue?vue&type=template&id=3e930180&scoped=true"
import script from "./AdvantagesSection.vue?vue&type=script&lang=js"
export * from "./AdvantagesSection.vue?vue&type=script&lang=js"
import style0 from "./AdvantagesSection.vue?vue&type=style&index=0&id=3e930180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e930180",
  null
  
)

export default component.exports